/**
 * Duração do áudio em segundos (mínimo 1) a partir de um Blob/File — mesmo padrão do chat (MessageInput).
 */
export default function getAudioDurationSeconds(blob) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);
    audio.onloadedmetadata = () => {
      const seconds = Math.max(1, Math.ceil(audio.duration || 0));
      URL.revokeObjectURL(url);
      resolve(seconds);
    };
    audio.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(1);
    };
  });
}
